import { Box, Dropdown, Menu, MenuButton, MenuItem } from "@mui/joy";
import { DotsThreeVertical, Trash, Flag, Prohibit } from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { apiFetch } from "../../../../utils/apiClient";
import ModalConfirmDelete from "../../ModalConfirmDelete/ModalConfirmDelete";
import ModalComplain from "../../ModalComplain/ModalComplain";
import { useBlock } from "../../../../hooks/service/useBlock";

const handlerDeleteChat = async (userId = 0) => {
    try {
        const res = await apiFetch(`/api/messages/${userId}`, {
            method: 'DELETE',
        });

        if (!res.ok) throw new Error("Не удалось удалить сообщения");

        const data = await res.json();

        return data?.success;
    } catch (err) {
        console.error("Не удалось удалить сообщения");
    }
}

export default function ChatDisplayMoreMenu({ userId = 0, bookmark = false, chatId = null, onBlockChange = () => { } }) {
    const navigate = useNavigate();
    const [openConfirm, setOpenConfirm] = useState(false);
    const [openComplain, setOpenComplain] = useState(false);
    const { blocked, loading: blockLoading, toggle: toggleBlock } = useBlock(userId, !bookmark);

    const handleToggleBlock = async () => {
        const data = await toggleBlock();
        onBlockChange(data?.blocked ?? !blocked);
    };

    const deleteMessages = async () => {
        const success = await handlerDeleteChat(userId);
        setOpenConfirm(false);
        if (success) {
            navigate('/messages');
        }
    }

    return (
        <Box sx={{ ml: 'auto' }}>
            <Dropdown>
                <MenuButton
                    slots={{ root: Box }}
                    slotProps={{
                        root: {
                            role: 'button',
                            tabIndex: 0,
                            sx: {
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: '50%',
                                padding: '6px',
                                cursor: 'pointer',
                                color: 'neutral.600',
                                '&:hover': {
                                    backgroundColor: 'neutral.softHoverBg',
                                },
                                '&:focus-visible': {
                                    outlineOffset: '2px',
                                },
                                width: 36,
                                height: 36,
                            },
                        },
                    }}
                >
                    <DotsThreeVertical size={20} />
                </MenuButton>
                <Menu placement="bottom-end" variant="plain" sx={{ borderRadius: '12px' }}>
                    {!bookmark && (
                        <MenuItem onClick={handleToggleBlock} disabled={blockLoading} color="danger" sx={{ py: 1 }}>
                            <Prohibit size={20} />
                            {blocked ? 'Разблокировать' : 'Заблокировать'}
                        </MenuItem>
                    )}
                    {!bookmark && chatId && (
                        <MenuItem onClick={() => setOpenComplain(true)} color="danger" sx={{ py: 1 }}>
                            <Flag size={20} />
                            Пожаловаться
                        </MenuItem>
                    )}
                    <MenuItem onClick={() => setOpenConfirm(true)} color="danger" sx={{ py: 1 }}>
                        <Trash size={20} />
                        Удалить чат
                    </MenuItem>
                </Menu>
            </Dropdown>

            <ModalConfirmDelete
                open={openConfirm}
                setOpen={setOpenConfirm}
                onDelete={deleteMessages}
                title="Удалить чат?"
                desc="Все сообщения будут удалены безвозвратно."
                buttonActiveText="Удалить"
            />

            <ModalComplain
                open={openComplain}
                setOpen={setOpenComplain}
                complainFor={3}
                contentId={chatId}
            />
        </Box>
    );
}
